import React from 'react';

export function WidgetCuit ({ cuit }) {
    return (<span>{cuit.substring(0, 2)}-{cuit.substring(2, cuit.length - 1)}-{cuit.substring(cuit.length - 1)}</span>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetCuit.displayName = 'WidgetCuit';
}
